import React, { useEffect, useState } from "react";
import "./BugReport.style.scss";
import { jwtDecode } from "jwt-decode";
import { sendBugReportPHP, sendPlayerReportPHP } from "../../../utils/functions.ts";
import { getTodayEasternYMD } from "../../../utils/dateUtils.ts";
import { useNavBar } from "../../../Contexts/navbar.items.context.jsx";

const BugReport = () => {
    const { updateActiveSideButton } = useNavBar();
    const [userData, updateUserData] = useState(null);
    const [formData, setFormData] = useState({
        operating: "-",
        browser: "-",
        section: "-",
        bugDescription: "",
        correctFirst: "",
        correctLast: "",
        correctSchool : "",
        correctPosition : "",
        correctInformation : ""
    });
    const [reverse, setReverse] = useState(false);

    useEffect(() => {
        if (!userData) {
            const token = localStorage.getItem("user2026");
            if (token) {
                const theU = jwtDecode(token);
                updateUserData(theU);
            } else {
                console.warn("No token found in localStorage");
            }
        }
    }, [userData]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const sendBugReport = () => {
        const dataToSend = {
            ...formData,
            displayName: userData?.displayName || "Anonymous",
            team: userData?.team || "Unknown",
            date: getTodayEasternYMD(),
        };
        sendBugReportPHP(dataToSend);
        updateActiveSideButton(null);
    };

    const sendPlayerReport = () =>{
        const dataToSend = {
            ...formData,
            displayName: userData?.displayName || "Anonymous",
            team: userData?.team || "Unknown",
            date: getTodayEasternYMD(),
        };
        sendPlayerReportPHP(dataToSend);
        updateActiveSideButton(null);
    }

    const setView = (inval) => {
        setReverse(inval);
    }

    return (
        <div className="bugBox">
            <div className="row alert alert-success p-3 text-center">
                <div className="fw-bold">Thank you for reporting an error with FBX</div>
                <div className="text-center mt-1">Please try to give as much information as you can in the Error.</div>
                <div className="text-center mt-1 fw-bold">For Player Errors, Please use the Report Player Error</div>
            </div>

            <div className="col-44 offset-2 gap-2 d-flex justify-content-between mt-2" style={{ lineHeight: "35px" }}>
                <div className={`col-24 btn ${reverse ? 'btn-outline-navy' : 'btn-navy'}`} onClick={() => setView(false)}>Error Report</div>
                <div className={`col-24 btn ${reverse ? 'btn-navy' : 'btn-outline-navy'}`} onClick={() => setView(true)}>Player Error</div>
            </div>
            {!reverse ? (
                <div id="bugPart">
                    <div className="mt-4">
                        {/* Operating System Dropdown */}
                        <div className="d-flex align-items-center gap-2">
                            <div className="col-18 text-end">What Operating System are you using?</div>
                            <div className="col-28 text-start">
                                <select name="operating" className="form-control" value={formData.operating} onChange={handleInputChange}>
                                    <option value="-">Operating System</option>
                                    <option value="windows">Windows</option>
                                    <option value="macos">Mac OS</option>
                                    <option value="android_ios">Android IOS</option>
                                    <option value="apple_ios">Apple IOS</option>
                                </select>
                            </div>
                        </div>


                        {/* Browser Dropdown */}
                        <div className="d-flex align-items-center mt-1 gap-2">
                            <div className="col-18 text-end px-2">What Browser are you using?</div>
                            <div className="col-28 text-start">
                                <select name="browser" className="form-control" value={formData.browser} onChange={handleInputChange}>
                                    <option value="-">Browser</option>
                                    <option value="chrome">Chrome</option>
                                    <option value="firefox">Firefox</option>
                                    <option value="safari">Safari</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                        </div>

                        {/* Application Section Dropdown */}
                        <div className="d-flex align-items-center mt-1 gap-2">
                            <div className="col-18 text-end px-2">What Section of our Application is the Bug?</div>
                            <div className="col-28 text-start">
                                <select name="section" className="form-control" value={formData.section} onChange={handleInputChange}>
                                    <option value="-">Section</option>
                                    <option value="account">Account</option>
                                    <option value="Bug">Bug Report</option>
                                    <option value="legend">Legend</option>
                                    <option value="Fuzzt">Fuzzy Search</option>
                                    <option value="s1_search">S1 Search</option>
                                    <option value="s2_search">S2 Search</option>
                                    <option value="s3_search">S3 Search</option>
                                    <option value="l1_search">L1 Search</option>
                                    <option value="l2_search">L2 Search</option>
                                    <option value="overview_button">Overview Button</option>
                                    <option value="depth_chart">Depth Chart</option>
                                    <option value="export">Export</option>
                                    <option value="hard_data">Hard Data</option>
                                    <option value="transactions">Transactions</option>
                                    <option value="file_upload">File Upload</option>
                                    <option value="notes">Notes</option>
                                    <option value="reports">Reports</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Bug Description */}
                    <div className="py-3 text-center px-5 text-primary fw-bold">
                        Please give as much detail as possible, including any data you might have entered.
                    </div>
                    <div className="col-44 offset-2 mt-2">
                        <textarea name="bugDescription" className="form-control" rows="5" value={formData.bugDescription} onChange={handleInputChange}></textarea>
                    </div>
                    {/* Submit Button */}
                    <div className="mt-3 text-center">
                        <button className="btn btn-success col-48 text-white" onClick={sendBugReport}>
                            Send Error Report
                        </button>
                    </div>

                    {/* Display User Info */}
                    {userData?.displayName && (
                        <div className="mt-2 text-primary fw-bold text-center">
                            Sent By : {userData.displayName} [{userData.team}] [{getTodayEasternYMD()}]
                        </div>
                    )}
                </div>
            ) : (
                <div className="mt-4">
                    <div className="d-flex align-items-center gap-2">
                        <div className="col-18 text-end">Player First Name</div>
                        <div className="col-28 text-start">
                            <input className="form-control"  name="correctFirst"  placeholder="First Name" type="text" onChange={handleInputChange} value={formData.correctFirst} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2">
                        <div className="col-18 text-end">Player Last Name</div>
                        <div className="col-28 text-start">
                            <input className="form-control"  name="correctLast" placeholder="Last Name" type="text" onChange={handleInputChange}  value={formData.correctLast} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2">
                        <div className="col-18 text-end">University</div>
                        <div className="col-28 text-start">
                            <input className="form-control"  name="correctSchool"  placeholder="School" type="text" onChange={handleInputChange}  value={formData.correctSchool}/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2">
                        <div className="col-18 text-end">Position</div>
                        <div className="col-28 text-start">
                            <input className="form-control"  name="correctPosition"  placeholder="Position" type="text" onChange={handleInputChange}  value={formData.correctPosition}/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2">
                        <div className="col-18 text-end">Use this Space for Correction</div>
                        <div className="col-28 text-start">
                            <textarea  rows="5" name="correctInformation"  className="form-control" onChange={handleInputChange}  value={formData.correctInformation }></textarea>
                        </div>
                    </div>
                    <div className="mt-3 text-center">
                        <button className="btn btn-primary col-48 text-white" onClick={sendPlayerReport}>
                            Send Player Error
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BugReport;
